export default __webpack_public_path__ + "static/media/img_home_1.3abb8152.png";